// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Terms Info Modal CSS Module
 * Styles for displaying campaign terms and conditions in a modal.
 */
.JrQqmWlR1ENiHlbg9eDz {
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2e2e2e;
  z-index: 98;
}
.JXLcCREbiFzq4Qym1G9N {
  width: 100%;
  height: calc(100vh - 50px);
  gap: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #262626;
  margin-top: 50px;
  overflow-y: auto;
}
.FEpQcBnwzv7VLf4gP3ag {
  font-size: 14px;
  font-weight: bold;
  line-height: 16.41px;
  text-align: center;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: var(--font-family-primary);
}
.oUJlgS87O_q2UIe6VRfz {
  color: white;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  padding: 10px 20px;
  font-family: var(--font-family-primary);
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 90%;
  margin: 0 auto;
}
.gZAIRLk2C7r9JpR27Plh {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 101;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background-color: #48494b;
  padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/tabs/RulesTab/CampaignTermsInfoModal/CampaignTermsInfoModal.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/**\n * Campaign Terms Info Modal CSS Module\n * Styles for displaying campaign terms and conditions in a modal.\n */\n.modalContainer {\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #2e2e2e;\n  z-index: 98;\n}\n.modalContentWrapper {\n  width: 100%;\n  height: calc(100vh - 50px);\n  gap: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #262626;\n  margin-top: 50px;\n  overflow-y: auto;\n}\n.modalTitle {\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16.41px;\n  text-align: center;\n  color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: var(--font-family-primary);\n}\n.termsText {\n  color: white;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.5;\n  text-align: left;\n  padding: 10px 20px;\n  font-family: var(--font-family-primary);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-width: 90%;\n  margin: 0 auto;\n}\n.closeModalIcon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 101;\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  background-color: #48494b;\n  padding: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `JrQqmWlR1ENiHlbg9eDz`,
	"modalContentWrapper": `JXLcCREbiFzq4Qym1G9N`,
	"modalTitle": `FEpQcBnwzv7VLf4gP3ag`,
	"termsText": `oUJlgS87O_q2UIe6VRfz`,
	"closeModalIcon": `gZAIRLk2C7r9JpR27Plh`
};
export default ___CSS_LOADER_EXPORT___;
